import DOMPurify from "dompurify";
import { DownCarrot } from "components/atoms/Icon";
import { formatDuration } from "utils/formatting";
import { useCollapsible } from "../shared/useCollapsible";
import styles from "./ThoughtsSection.module.scss";

interface ThoughtsSectionProps {
    thoughts: string;
    thinkingDuration: number;
}

function ThoughtsSection({ thoughts, thinkingDuration }: ThoughtsSectionProps) {
    const { isExpanded, handleToggle, handleKeyDown } = useCollapsible();

    if (!thoughts) {
        return null;
    }

    const durationText = formatDuration(thinkingDuration);

    if (!isExpanded) {
        return (
            <div className={styles.collapsedBadge}>
                <button
                    type="button"
                    onClick={handleToggle}
                    onKeyDown={handleKeyDown}
                    className={styles.toggleButton}
                    aria-expanded={false}
                    aria-label={`Thought for ${durationText}. Click to expand`}
                >
                    <span className={styles.badgeText}>Thought for {durationText}</span>
                    <span className={`${styles.chevronIcon} ${styles.chevronDown}`}>
                        <DownCarrot />
                    </span>
                </button>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.title}>Thought for {durationText}</span>
                <button
                    type="button"
                    onClick={handleToggle}
                    onKeyDown={handleKeyDown}
                    className={styles.collapseButton}
                    aria-expanded={true}
                    aria-label="Collapse thoughts"
                    title="Collapse"
                >
                    <span className={`${styles.chevronIcon} ${styles.chevronUp}`}>
                        <DownCarrot />
                    </span>
                </button>
            </div>
            <div
                className={styles.content}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(thoughts),
                }}
            />
        </div>
    );
}

export default ThoughtsSection;
